import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useReducedMotion } from "framer-motion";
import { RouteFallback } from "@/components/RouteFallback";
import { MarketingHeader } from "./MarketingHeader";
import { MarketingFooter } from "./MarketingFooter";

export function MarketingLayout() {
  const { pathname, hash, key } = useLocation();
  const reduce = useReducedMotion();

  // Nouvelle page : en haut. Ancre (/#cabinets) : la section visée, même
  // depuis une autre page ; le décalage sous l'en-tête vient de
  // scroll-padding-top (index.css).
  useEffect(() => {
    let id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch { /* Une ancre invalide ne bloque pas la navigation. */ }
    function revealTarget() {
      const target = id ? document.getElementById(id) : null;
      if (!target) return false;
      target.scrollIntoView({
        behavior: reduce ? "auto" : "smooth",
        block: "start",
      });
      return true;
    }
    if (revealTarget()) return;
    window.scrollTo({ top: 0, behavior: "instant" });
    const main = document.getElementById("contenu");
    if (!id || !main) return;
    // Une page chargée à la demande peut arriver après l’effet du layout.
    const observer = new MutationObserver(() => {
      if (revealTarget()) observer.disconnect();
    });
    observer.observe(main, { childList: true, subtree: true });
    const timeout = window.setTimeout(() => observer.disconnect(), 10_000);
    return () => { observer.disconnect(); window.clearTimeout(timeout); };
  }, [pathname, hash, key, reduce]);

  return (
    <div className="flex min-h-dvh flex-col bg-canvas text-foreground">
      <a
        href="#contenu"
        className="fixed top-3 left-3 z-[60] -translate-y-[200%] rounded-lg bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground transition-[translate] duration-150 focus-visible:translate-y-0 focus-visible:shadow-pop focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
      >
        Aller au contenu
      </a>
      <MarketingHeader />
      <main id="contenu" tabIndex={-1} className="flex-1 focus:outline-none">
        {/* Le Suspense reste d'une page à l'autre : en navigation, la page
            affichée reste en place tant que la suivante n'est pas arrivée. */}
        <Suspense fallback={<RouteFallback />}>
          <div key={pathname} className="enc-page">
            <Outlet />
          </div>
        </Suspense>
      </main>
      <MarketingFooter />
    </div>
  );
}
